/**
 * Options for registering a webhook for listening events for a specific session
 */
export interface WebhookRegisterOptions {
  /**
   * Webhook URL which is to be registered
   */
  webhook_url: string;
  /**
   * Name of the webhook
   */
  name: string;
  /**
   * Description regarding the webhook
   */
  description: string;
}

/**
 * Response of register webhook API request
 */
export interface WebhookRegisterResponse {
  /**
   * Webhook secret which is used to verify the incoming request
   */
  webhook_secret: string;
}

/**
 * Options for verifying the webhook's signature
 */
export interface WebhookVerifyOptions {
  /**
   * Incoming request headers
   */
  headers: Record<string, string>;
  /**
   * Incoming request payload
   */
  payload: string;
  /**
   * Webhook secret which is returned by the webhook.register function
   */
  webhook_secret: string;
}
